import { Upload } from '@/types';
import React, { useCallback, useState } from 'react';
import { StagedFile } from '../tabs/PhotoUploadTab';

export const usePhotoUploads = () => {
  const [uploadedPhotos, setUploadedPhotos] = useState<Upload[]>([]);
  const [stagedFiles, setStagedFiles] = useState<StagedFile[]>([]);

  const handleNewFiles = useCallback((files: File[]) => {
    const newStagedFiles: StagedFile[] = files.map((file) => ({
      id: crypto.randomUUID(),
      file,
      previewUrl: URL.createObjectURL(file),
    }));
    setStagedFiles((prev) => [...prev, ...newStagedFiles]);
  }, []);

  const handleRemoveStagedFile = useCallback((idToRemove: string) => {
    setStagedFiles((prev) => {
      const fileToRemove = prev.find((f) => f.id === idToRemove);
      if (fileToRemove) {
        URL.revokeObjectURL(fileToRemove.previewUrl);
      }
      return prev.filter((f) => f.id !== idToRemove);
    });
  }, []);

  const handleUploadComplete = useCallback((newlyUploaded: Upload[]) => {
    setUploadedPhotos((prev) => [...prev, ...newlyUploaded]);
    setStagedFiles([]);
  }, []);

  return {
    handleNewFiles,
    handleRemoveStagedFile,
    handleUploadComplete,
    uploadedPhotos,
    setUploadedPhotos,
    stagedFiles,
    setStagedFiles,
  };
};
